import { StripePaymentErrors } from '@spinnaker/iliad/dist/utils/payments/StripePaymentProcessor'

export interface ScaFailure {
  kind: Exclude<PaymentSubmissionKind, 'success'>
  trackingReason: PaymentTrackingErrorReason
  detail: unknown
  error: Error
  log: { level: 'warn' | 'error'; message: string; data: Record<string, unknown> }
}

export function classifyScaFailure(error: unknown): ScaFailure {
  const scaError = error instanceof Error ? error : new Error('Unknown error')
  const cause = scaError.cause as { code?: string; message?: string } | undefined
  const detail = cause?.message ?? scaError

  if (scaError.message === StripePaymentErrors.SCA_DENIED) {
    return {
      kind: 'declined',
      trackingReason: 'sca_denied',
      detail,
      error: new Error(StripePaymentErrors.SCA_DENIED),
      log: {
        level: 'warn',
        message: 'Payment: 3D Secure authentication denied by user',
        data: { stripeErrorCode: cause?.code }
      }
    }
  }

  if (scaError.message === StripePaymentErrors.SCA_ERROR) {
    return {
      kind: 'error',
      trackingReason: 'sca_error',
      detail,
      error: new Error(StripePaymentErrors.SCA_ERROR),
      log: {
        level: 'warn',
        message: 'Payment: 3D Secure authentication failed',
        data: { error: scaError.message, cause: cause?.message }
      }
    }
  }

  return {
    kind: 'error',
    trackingReason: 'sca_unexpected',
    detail,
    error: new Error(StripePaymentErrors.SCA_ERROR),
    log: {
      level: 'error',
      message: 'Payment: 3D Secure authentication failed unexpectedly',
      data: { error: scaError }
    }
  }
}
